import { Box, Tooltip, Typography } from '@mui/material';

import { FileStatus } from '../../../../../../api/theHive/redeProto/types';
import {
  IconCancelMS,
  IconCheckCircleMS,
  IconPendingMS,
} from '../../../../../../constants/icons';
import { AxisAggregate } from './types';

interface StatusIconProps {
  status: FileStatus | AxisAggregate;
}

const ICONS: Record<
  'approved' | 'pending' | 'rejected',
  { icon: JSX.Element; color: string; label: string }
> = {
  approved: { icon: IconCheckCircleMS, color: '#2E7D32', label: 'Aprovado' },
  rejected: { icon: IconCancelMS, color: '#C62828', label: 'Reprovado' },
  pending: { icon: IconPendingMS, color: '#ED6C02', label: 'Pendente' },
};

export function StatusIcon({ status }: StatusIconProps): JSX.Element {
  // 'not_sent' (nunca enviado) → em branco.
  if (status === 'not_sent') {
    return (
      <Tooltip title="Nunca enviado">
        <Box component="span" sx={{ display: 'inline-block', width: 24 }} />
      </Tooltip>
    );
  }

  // 'na' (eixo sem arquivos) → "—".
  if (status === 'na') {
    return (
      <Tooltip title="Sem documentos neste eixo">
        <Typography color="text.secondary">—</Typography>
      </Tooltip>
    );
  }

  const { icon, color, label } = ICONS[status];
  return (
    <Tooltip title={label}>
      <Box
        component="span"
        sx={{ color, display: 'inline-flex', '& svg': { fontSize: 22 } }}
      >
        {icon}
      </Box>
    </Tooltip>
  );
}
